import { getDataFromStores } from '../../../../../shared/utils';
import store from '../../store';

export const getCommonStores = () =>
    getDataFromStores(store.brief, store.user, store.pagePath, store.sellerId, store.projectId, store.variationId);
